export function BarChartIcon({ size = 35, className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color="white"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M3 11L3 21M15 11L15 21M9 3L9 21M21 3V21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}